<template>
  <div id="app">
    <the-navbar />
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
import TheNavbar from '@/components/TheNavbar'

export default {
  name: 'App',
  components: {
    TheNavbar
  }
}
</script>

<style lang="scss">
@import '~buefy/dist/buefy.css';

.mb-1 {
  margin-bottom: 1vh;
}

@media screen and (max-width: 1024px) {
  .columns {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
